import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

// Extrage ID-ul din orice format de link YouTube
export const getYouTubeId = (url) => {
    if (!url) return null;
    const match = url.match(
        /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/
    );
    return match ? match[1] : null;
};

// Embed responsive 16:9. Primește fie un link complet, fie un videoId.
export function YouTubeEmbed({ url, videoId, title }) {
    const id = videoId || getYouTubeId(url);
    if (!id) return null;
    return (
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, margin: '15px 0' }}>
            <iframe
                src={`https://www.youtube.com/embed/${id}`}
                title={title || 'YouTube video'}
                style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0, borderRadius: '8px' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
}

// Folosire pe orice pagină: <YouTubeSection page="home" />
// Valori posibile pentru page: home, articles, traintravel, coaching
export default function YouTubeSection({ page, heading }) {
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        const q = query(collection(db, "youtubeLinks"), where("page", "==", page));
        const unsub = onSnapshot(q, (snap) => {
            const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            // Sortare în JS ca să nu fie nevoie de index compus în Firestore
            list.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
            setVideos(list);
        });
        return () => unsub();
    }, [page]);

    if (videos.length === 0) return null;

    return (
        <div className="youtube-section">
            {heading && <h2>{heading}</h2>}
            <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                {videos.map(v => (
                    <div key={v.id}>
                        {v.title && <h4>{v.title}</h4>}
                        <YouTubeEmbed videoId={v.videoId} title={v.title} />
                    </div>
                ))}
            </div>
        </div>
    );
}